import { Injectable } from '@angular/core';

/* tslint:disable:no-console */

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  public log(...args: any[]) {
    console.log(...args);
  }
  public info(...args: any[]) {
    console.info(...args);
  }
  public warn(...args: any[]) {
    console.warn(...args);
  }
  public error(...args: any[]) {
    console.error(...args);
  }
}

/* tslint:enable:no-console */
